import React, {useContext, useEffect, useRef, useState} from 'react';
import {FormattedMessage} from "react-intl";

import {Card, CardContent, Grid} from "@mui/material";

import MobileItem from "components/WMS/Mobile/MobileItem";
import ThumbnailAndNotification from "components/WMS/Mobile/ThumbnailAndNotification";
import RightDrawer from "components/WMS/Mobile/RightDrawer";
import CustomButton from "components/CustomButton";

import WmsMobileLayout from "../../wmsMobileLayout";
import NoTrolleyPopup from "./NoTrolleyPopup";
import StopSortingPopup from "./StopSortingPopup";

import {ReactComponent as ArrowRightIcon} from "assets/img/wms/arrow-right.svg";
import ToBeSortedSingleTrolley from "./MerchantList/component/ToBeSortedSingleTrolley/ToBeSortedSingleTrolley";
import {getReadyToBeSortedItem, getWMSContainerWithCodeBar, patchWMSContainerMemberWithCodebar} from "api/wms/wmsContainers/wmsContainers";
import {WMSContext} from "../../context/WMSContext";
import {BarCodeScannerContext} from "contexts/barCodeScannerContext";

import {WMSRoutes} from "utils/WMSRoutes";
import MerchantList from "./MerchantList";
import {SortingContext} from "./SortingContext";
import {WmsContainerType} from "../../../../utils/WMSContainerType";


function ToBeSortedTrolleys() {
    const {currentInventory, currentMember, currentOrganization, redirect} = useContext(WMSContext)
    const {scannedString, setEnableScan} = useContext(BarCodeScannerContext)
    const [containers, setContainers] = useState([])
    const [selectedContainer, setSelectedContainer] = useState()
    const [selectedContainerIndex, setSelectedContainerIndex] = useState(0)
    const [selectedRetailer, setSelectedRetailer] = useState(null)
    const [openMerchantDrawer, setOpenMerchantDrawer] = useState(false)
    const [openProductDrawer, setOpenProductDrawer] = useState(false)
    const [isScanned, setIsScanned] = useState(false)
    const [massTransfer, setMassTransfer] = useState(false)
    const [massTransferToStack, setMassTransferToStack] = useState(false)
    const [openQuitMissionPopup, setOpenQuitMissionPopup] = useState(false)
    const containerFetchCancelledRef = useRef(false)
    const [inSorting, setInSorting] = useState(false)

    const loading = useRef(true);

    const handleRefreshTrolley = (removedItems) => {
        setSelectedContainer(prev => ({
            ...prev,
            wmsItems: prev.wmsItems.filter(item => !removedItems.some(removedItem => removedItem.id === item.id)),
        }))
    }

    const closeMerchantDrawerCleanly = () => {
        containerFetchCancelledRef.current = true
        setOpenMerchantDrawer(false)
        setOpenProductDrawer(false)
        setSelectedContainer(undefined)
        setSelectedRetailer(null)
        setIsScanned(false)
        setInSorting(false)
        setOpenQuitMissionPopup(false)
    }

    const handleCloseMerchantDrawer = () => {
        if (inSorting) {
            setOpenQuitMissionPopup(true)
            return
        }
        closeMerchantDrawerCleanly()
    }

    const handleStopSorting = () => {
        setOpenQuitMissionPopup(true)
    }

    const handleFinishSorting = () => {
        patchWMSContainerMemberWithCodebar(selectedContainer.codebar, null).then(closeMerchantDrawerCleanly)
    }

    const handleBackFromProducts = () => {
        setSelectedRetailer(null)
        setOpenProductDrawer(false)
    }

    const openMerchantSelection = (container, containerIndex) => {
        setSelectedContainer(container)
        setSelectedContainerIndex(containerIndex)
        setOpenMerchantDrawer(true)
    }

    const openProductList = (retailer) => {
        setSelectedRetailer(retailer)
        setOpenProductDrawer(true)
    }

    const handleStartSorting = (currentContainer = null) => {
        patchWMSContainerMemberWithCodebar(currentContainer?.codebar ?? selectedContainer.codebar, currentMember).then(() => {
            setInSorting(true)
            setEnableScan(true)
        })
    }

    function listTrolleys() {
        loading.current = true
        getReadyToBeSortedItem(currentInventory).then((response) => {
            setContainers(response)
            setEnableScan(true)
        }).finally(() => {
            loading.current = false
        })
    }

    useEffect(() => {
        if (scannedString && scannedString.length > 0 && !openProductDrawer && !selectedContainer) {
            setEnableScan(false)
            const matchIndex = containers.findIndex((container) => container.codebar === scannedString)
            if (matchIndex !== -1) {
                setIsScanned(true)
                setSelectedContainer(containers[matchIndex])
                setSelectedContainerIndex(matchIndex + 1)
                setOpenMerchantDrawer(true)
            } else {
                setEnableScan(true)
            }
        }
    }, [scannedString]);

    useEffect(() => {
        if (false === openProductDrawer && selectedContainer) {
            containerFetchCancelledRef.current = false
            getWMSContainerWithCodeBar(selectedContainer.codebar).then(response => {
                if (!containerFetchCancelledRef.current) {
                    setSelectedContainer(response)
                }
            })
        }
    }, [openProductDrawer]);

    useEffect(() => {
        if (currentInventory && false === openMerchantDrawer) {
            listTrolleys();
        }
    }, [currentInventory, openMerchantDrawer]);

    // when coming from picking view
    useEffect(() => {
        const currentMemberIndex = containers.findIndex((container) => container.member?.id && container.member.id === currentMember.id)
        if (currentMemberIndex !== -1 && !selectedContainer) {
            setSelectedContainer(containers[currentMemberIndex])
            setSelectedContainerIndex(currentMemberIndex + 1)
            setOpenMerchantDrawer(true)
        }
    }, [containers]);

    useEffect(() => {
        if (currentOrganization) {
            setMassTransfer(currentOrganization.massTransfer ? currentOrganization.massTransfer : false )
            setMassTransferToStack(currentOrganization.massTransferToStack ? currentOrganization.massTransferToStack : false)
        }
    }, [currentOrganization]);

    if (0 === containers.filter((container) => !container.member).length && loading.current === false && !selectedContainer) {
        return (
            <NoTrolleyPopup
                open={true}
                handleClose={() => redirect(WMSRoutes.DASHBOARD)}
                onClick={() => listTrolleys()}
            />
        )
    }

    return (
        <>
            {selectedContainer && (
                <SortingContext.Provider value={{
                    inSorting,
                    isScanned,
                    massTransfer,
                    massTransferToStack,
                    selectedContainer,
                    selectedContainerIndex,
                    currentMember,
                    currentInventory,
                    setInSorting,
                    handleStartSorting,
                    handleStopSorting,
                    handleFinishSorting,
                    refreshTrolley: handleRefreshTrolley,
                }}
                >
                    <MerchantList
                        open={openMerchantDrawer} // Parent
                        handleClose={handleCloseMerchantDrawer} // Parent
                        openProductList={openProductList} // MerchantList
                    />

                    <StopSortingPopup
                        open={openQuitMissionPopup}
                        onConfirm={() => patchWMSContainerMemberWithCodebar(selectedContainer.codebar, null).then(closeMerchantDrawerCleanly)}
                        onCancel={() => setOpenQuitMissionPopup(false)}
                    />
                </SortingContext.Provider>
            )}

            <Card sx={{
                marginBottom: '32px',
                boxShadow: 0,
                padding: '0 0',
            }}>
                <CardContent sx={{paddingX: 0}}>
                    <Grid container direction={"column"}>
                        {containers.filter((container) => !container.member).map((container, index) => {
                            let containMulti = false
                            let containMono = false
                            container.wmsItems.forEach((item) => {
                                if (item.lineItem.currentShipment.multi && !containMulti) {
                                    containMulti = true
                                }

                                if (!item.lineItem.currentShipment.multi && !containMono) {
                                    containMono = true
                                }
                            })
                            return (
                                <Grid item key={container.id}>
                                    <div onClick={() => openMerchantSelection(container, index + 1)}>
                                        <MobileItem>
                                            <MobileItem.LeftSide
                                                title={<><FormattedMessage id={WmsContainerType.STACK === container.type ? 'wms.sorting.inSorting.stack.title' : 'wms.sorting.inSorting.trolley.title'}/> {container.name ?? (index + 1)}</>}
                                                subtitle={
                                                    <>
                                                        {containMulti && <FormattedMessage id={"wms.sorting.multi"}/>}
                                                        {containMulti && containMono && "/"}
                                                        {containMono && <FormattedMessage id={"wms.sorting.mono"}/>} · {container.wmsItems.length} <FormattedMessage id={"wms.sorting.article"}/>
                                                    </>
                                                }
                                            />
                                            <MobileItem.RightSide>
                                                <ArrowRightIcon/>
                                            </MobileItem.RightSide>
                                        </MobileItem>
                                    </div>
                                </Grid>
                            )
                        })}
                    </Grid>
                </CardContent>
            </Card>
        </>
    )
}

export default ToBeSortedTrolleys;
